{
  "record": "Team",
  "index": {
    "title": "Teams",
    "create": "Create Team",
    "join": "Join Team",
    "empty_list_title": "No Teams",
    "empty_list_description": "Click the create button to create your first team or visit the search page to join a team.",
    "members": "Members",
    "invitations": "Invitations",
    "team_applications": "Applications",
    "team_timetable": "Timetable"
  },
  "new": {
    "title": "New Team"
  },
  "edit": {
    "title": "Edit Team"
  }
}
